import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography
} from "@mui/material";
import { Help20Px as QuestionMarkIcon } from "@qubit/autoparts";

import { useTranslation } from "react-i18next";

type HandRaiseReminderModalProps = {
  isOpen?: boolean;
  variant: "login" | "logout";
  onLowerHand: () => void;
  onKeepHandRaised: () => void;
  onCancel?: () => void;
};

const HandRaiseReminderModal = ({
  isOpen = true,
  variant: _variant,
  onLowerHand,
  onKeepHandRaised,
  onCancel
}: HandRaiseReminderModalProps) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={isOpen}
      fullWidth
      maxWidth="sm"
      onClose={(_, reason) => {
        if (reason === "backdropClick") return;
        if (onCancel) onCancel();
      }}
      disableEscapeKeyDown
      slotProps={{ paper: { sx: { borderRadius: 3 } } }}
    >
      <DialogTitle>{t("hand raised")}</DialogTitle>

      <DialogContent
        sx={{
          mt: 1,
          px: { xs: 3, sm: 5 },
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center"
        }}
      >
        <QuestionMarkIcon
          fill="#b78933"
          style={{
            width: "4em",
            height: "4em",
            marginTop: "1em",
            marginBottom: "1em"
          }}
        />
        <Typography variant="h6" sx={{ mb: 2 }}>
          {t("Still need help?")}
        </Typography>

        <Typography variant="body1" sx={{ mb: 2 }}>
          {t(
            "A hand was previously raised at this workstation.  Does something need to be resolved?"
          )}
        </Typography>
      </DialogContent>

      <DialogActions sx={{ justifyContent: "center", gap: 2, p: 3 }}>
        <Button
          size="large"
          variant="contained"
          color="secondary"
          onClick={onKeepHandRaised}
        >
          {t("keep hand raised")}
        </Button>

        <Button size="large" variant="contained" onClick={onLowerHand}>
          {t("lower hand")}
        </Button>

        {onCancel && (
          <Button
            size="large"
            variant="text"
            color="secondary"
            onClick={onCancel}
          >
            {t("cancel")}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default HandRaiseReminderModal;
